import { Model } from "backbone";
import { attribute } from "marionette-decorators";

class FormModel extends Model {

    referenceNumber = 0;
    _token = undefined;
    _url = undefined;

    constructor (attributes, options) {
        super(attributes, options);
        this.referenceNumber = attributes.referenceNumber;
        this._token = attributes.token;
    }

    /**
     *  Root URL of resource on server.
     */
    get url () {
        let url = this.DEFAULT_URL;
        
        if (this._token != null) {
            url += `?token=${this._token}`;
        }

        return url;
    }

    get DEFAULT_URL () {
        return `${GLOBALS.API_URL}/onboarding-forms/${this.referenceNumber}`;
    }

    set url (url) {
        this._url = url;
    }

    set token (token) {
        this._token = token;
    }

}

export default FormModel;


// WEBPACK FOOTER //
// ./public/domain/models/form.js